module.exports = __webpack_public_path__ + "static/media/Ermakov.76811e76.png";